import { z } from 'zod';
import { TFunction } from '../_hooks/useAddProductSchema';

// Typed shape for an Ant Design / react-dropzone upload file object
const uploadedFileSchema = z.object({
  uid: z.string(),
  name: z.string(),
  url: z.string().optional(),
  originFileObj: z.custom<File>().optional(),
  status: z.string().optional(),
  uploading: z.boolean().optional(),
});

const regex =
  /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0020-\u007E\u00A0-\u00FF\u0100-\u024F0-9!@#$%^&*()_+={}[\]:;"'<>,.?/\\|\s-]*$/;

const certificateSchema = z.object({
  uid: z.string(),
  name: z.string(),
  url: z.string(),
  certificateName: z.string().min(3).max(20).regex(regex),
  type: z.string().optional(),
  uploading: z.boolean().optional(),
});

export const getCustomizationSchema = (t: TFunction) =>
  z.object({
    customizationTypes: z.array(z.string()).optional(),
    customLogo: z.array(uploadedFileSchema).optional(),
    certificatesDocuments: z
      .array(certificateSchema)
      .max(5, { message: t('maxItems', { value: 5 }) })
      .optional(),
    acceptSampleOrder: z.boolean().default(false),
    minSampleQty: z.preprocess(
      (val) =>
        val === '' || val === undefined || val === null
          ? undefined
          : Number(val),
      z
        .number()
        .int()
        .positive({ message: t('acceptNumbersOnly') })
        .optional()
    ),
    samplePrice: z.preprocess(
      (val) =>
        val === '' || val === undefined || val === null
          ? undefined
          : Number(val),
      z
        .number()
        .int()
        .positive({ message: t('acceptNumbersOnly') })
        .optional()
    ),
    hasCustomLogo: z.boolean().optional(),
  });
